import type { RequisiteType } from './api';
export { detectBankPlatform as detectKztBankPlatform, getBankTarget as getKztBankTarget } from './bankApps';

interface KztBankPaymentEligibility {
    orderType?: string | null;
    fiatCurrency?: string | null;
    requisiteType?: RequisiteType | null;
    status: string;
    actionsExpired: boolean;
}

export const isKztBankPaymentEligible = ({
    orderType,
    fiatCurrency,
    requisiteType,
    status,
    actionsExpired,
}: KztBankPaymentEligibility): boolean => (
    orderType === 'deposit'
    && (fiatCurrency?.trim().toUpperCase() === 'KZT' || requisiteType?.startsWith('kzt_') === true)
    && status === 'assigned'
    && !actionsExpired
);
